import { render, staticRenderFns } from "./patrolTab.vue?vue&type=template&id=262b097d"
import script from "./patrolTab.vue?vue&type=script&lang=js"
export * from "./patrolTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('262b097d')) {
      api.createRecord('262b097d', component.options)
    } else {
      api.reload('262b097d', component.options)
    }
    module.hot.accept("./patrolTab.vue?vue&type=template&id=262b097d", function () {
      api.rerender('262b097d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/vendor/patrolTab.vue"
export default component.exports